export const stringMapDefault = {
    week: "<span>week </span>{weekNumber}"
};
